import '../../../App.css';
import { useState, useEffect } from 'react';
import { Table, Button, Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import {
    fetchBannersAsync,
    deleteBannerAsync
} from '../../../redux/slice/banner/bannerSlice';
import Appconfig from '../../../config/config';
import AddBannerModal from './components/AddBannerModal';

function Banner() {
    const dispatch = useDispatch();
    const { banners, loading } = useSelector(state => state.banner);
    const { userdata, isAuthenticated } = useSelector(state => state.authSlice);
    const [openBannerModal, setOpenBannerModal] = useState(false);
    const [currentBanner, setCurrentBanner] = useState(null);
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchBannersAsync(Appconfig.sitecodes));
        }
    }, [dispatch]);

    const handleDeleteBanner = (bannerId) => {
        dispatch(deleteBannerAsync({
            bannerId,
            siteCode: Appconfig.sitecodes
        }));
    };

    const handleEditBanner = (banner) => {
        setCurrentBanner(banner);
        setOpenBannerModal(true);
    };

    const columns = [
        {
            title: 'Image',
            dataIndex: 'image_name',
            render: (_, record) => (
                <Image
                    width={450}
                    src={`${Appconfig.apiUrl}banner/${record.image_name}`}
                    alt="Banner"
                />
            ),
        },
        {
            title: 'Actions',
            render: (_, record) => (
                <div className='flex items-center gap-x-4'>
                    <Button
                        onClick={() => handleDeleteBanner(record._id)}
                        type="danger"
                        className='flex items-center justify-center'
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            viewBox="0 0 26 26"
                        >
                            <path
                                fill="currentColor"
                                d="M16.162,0.213H9.838C9.358,0.535,9.005,1.049,8.78,1.821H2.233c-0.191,0-0.32,0.097-0.32,0.29v2.541 c0,0.193,0.129,0.29,0.32,0.322h21.534c0.224-0.032,0.32-0.129,0.32-0.322V2.111c0-0.193-0.097-0.29-0.32-0.29h-6.514 C16.995,1.049,16.643,0.535,16.162,0.213z"
                            />
                            <path
                                fill="currentColor"
                                d="M19.725,25.788c1.088-0.453,1.698-1.256,1.795-2.415c0-0.031,0-0.062,0-0.097l1.058-16.694H3.454 l1.027,16.694c0,0.035,0,0.065,0.031,0.097c0.096,1.159,0.674,1.962,1.765,2.415H19.725z"
                            />
                        </svg>
                    </Button>
                </div>
            )
        },
    ];
    return (
        <>
            <AddBannerModal
                open={openBannerModal}
                onCancel={() => {
                    setOpenBannerModal(false);
                    setCurrentBanner(null);
                }}
                currentBanner={currentBanner}
            />
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px] px-[15px] lg:px-[30px]'>
                    <div className='col-span-12 lg:mx-auto'>
                        <div className='lg:block w-full lg:w-[40vw]'>
                            <div className='grid grid-cols-12'>
                                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-[1px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>Banner Management</h5>
                                </div>

                                <div className='col-span-12'>
                                    <div className='bg-[#fff] border-[1px] border-[#0000002d]'>
                                        <div className='text-end p-[0.75rem] flex-auto'>
                                            <button
                                                type='button'
                                                className='text-white bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] text-[.875rem] rounded-[.25rem] px-[10px] mt-[10px] py-[5px]'
                                                onClick={() => setOpenBannerModal(true)}
                                            >
                                                Add Banner
                                            </button>
                                        </div>
                                        <div className='p-[0.75rem] flex-auto'>
                                            <Table
                                                columns={columns}
                                                className='downline-list'
                                                bordered
                                                dataSource={banners}
                                                loading={loading}
                                                pagination={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Banner;